export const normalizeSupplyQuantity = value => {
  if (value === '' || value === null || value === undefined) return '';
  const numeric = Number(value);
  return Number.isFinite(numeric) ? numeric : 0;
};

export const getValidSupplyPayload = list =>
  (Array.isArray(list) ? list : [])
    .filter(item => item && item.supplyId !== null && item.supplyId !== undefined && item.supplyId !== '')
    .map(item => ({
      supplyId: item.supplyId,
      quantity: normalizeSupplyQuantity(item.quantity)
    }))
    .filter(item => item.quantity !== '' && Number(item.quantity) > 0);
